<vg-player style="height: 50px;" (onPlayerReady)="onPlayerReady($event)">
    <vg-buffering></vg-buffering>

    <vg-controls>
        <vg-play-pause></vg-play-pause>
        <vg-scrub-bar>
            <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
            <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
        </vg-scrub-bar>
        <vg-time-display vgProperty="left" vgFormat="mm:ss"></vg-time-display>
        <vg-mute></vg-mute>
    </vg-controls>

    <audio #media (onGetBitrates)="bitrates = $event"
        [vgMedia]="media" [vgHls]="currentStream?.source"
        id="audioPlayer" type="application/x-mpegurl; audio-only" 
        vg-preload="'preload'"
    ></audio>
</vg-player>